<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="max-h-[90vh] max-w-lg overflow-y-auto">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>{{ location() ? 'Standort bearbeiten' : 'Standort hinzufügen' }}</h3>
      <p hlmDialogDescription>
        Der Standort erscheint mit Adresse und Kartenpunkt auf deiner Shop-Seite.
      </p>
    </div>

    <form
      id="store-location-form"
      class="grid gap-4 sm:grid-cols-2"
      [formGroup]="form"
      (ngSubmit)="submit()">
      <div hlmField class="sm:col-span-2">
        <label hlmFieldLabel for="store-location-name">Name *</label>
        <input
          hlmInput
          id="store-location-name"
          type="text"
          formControlName="name"
          maxlength="100"
          placeholder="z. B. Filiale Innenstadt"
          class="w-full"
          [attr.aria-invalid]="isInvalid('name') ? 'true' : null" />
        @if (isInvalid('name')) {
          <p hlmFieldDescription class="text-destructive">Name ist erforderlich</p>
        } @else {
          <p hlmFieldDescription>So sehen Kunden den Standort in der Liste.</p>
        }
      </div>

      <div hlmField class="sm:col-span-2">
        <label hlmFieldLabel for="store-location-street">Straße & Hausnummer *</label>
        <input
          hlmInput
          id="store-location-street"
          type="text"
          formControlName="street"
          maxlength="200"
          placeholder="Geschäftsstraße 1"
          class="w-full"
          [attr.aria-invalid]="isInvalid('street') ? 'true' : null" />
        @if (isInvalid('street')) {
          <p hlmFieldDescription class="text-destructive">Straße ist erforderlich</p>
        }
      </div>

      <div hlmField>
        <label hlmFieldLabel for="store-location-zip">Postleitzahl *</label>
        <input
          hlmInput
          id="store-location-zip"
          type="text"
          inputmode="numeric"
          formControlName="zip"
          maxlength="20"
          placeholder="12345"
          class="w-full"
          [attr.aria-invalid]="isInvalid('zip') ? 'true' : null" />
        @if (isInvalid('zip')) {
          <p hlmFieldDescription class="text-destructive">Postleitzahl ist erforderlich</p>
        }
      </div>

      <div hlmField>
        <label hlmFieldLabel for="store-location-city">Stadt *</label>
        <input
          hlmInput
          id="store-location-city"
          type="text"
          formControlName="city"
          maxlength="100"
          placeholder="Musterstadt"
          class="w-full"
          [attr.aria-invalid]="isInvalid('city') ? 'true' : null" />
        @if (isInvalid('city')) {
          <p hlmFieldDescription class="text-destructive">Stadt ist erforderlich</p>
        }
      </div>

      <div hlmField class="sm:col-span-2">
        <label hlmFieldLabel for="store-location-country">Land *</label>
        <hlm-native-select
          selectId="store-location-country"
          class="w-full"
          formControlName="country">
          @for (country of countries; track country.code) {
            <option hlmNativeSelectOption [value]="country.code">{{ country.name }}</option>
          }
        </hlm-native-select>
      </div>

      @if (error()) {
        <div hlmAlert variant="destructive" role="alert" class="sm:col-span-2">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
        </div>
      }
    </form>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" (click)="close.emit()">Abbrechen</button>
      <button hlmBtn type="submit" form="store-location-form" [disabled]="saving()">
        @if (saving()) {
          <hlm-spinner />
        }
        {{ location() ? 'Speichern' : 'Hinzufügen' }}
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
